export default __webpack_public_path__ + "static/media/login-dark.31d6cfe0.svg";